<div class="main-container" [class.container-is-mobile]="mobileQuery.matches">
    <mat-toolbar color="primary" class="main-toolbar" *ngIf="currentUser">

        <div fxLayout="row">
            <div fxLayoutAlign="start center">
                <button mat-icon-button (click)="opened=!opened">
                    <mat-icon>menu</mat-icon>
                </button>
                <h1 class="app-name">{{title}}</h1>

            </div>
            <!-- <div  fxLayoutAlign="end center">
                <h1>  {{currentUser.Email}}</h1>
            </div> -->

        </div>

    </mat-toolbar>

    <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
        <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
            fixedTopGap="56" class="sideItems blue-background-color" *ngIf="currentUser" [(opened)]=opened>
            <div class="SidebarLogo mat-elevation-4">
                <img src="./../../assets/icons/grupo-montecristo.png">
            </div>
            <div class="SessionUser">
                {{currentUser.Email}}

            </div>

            <mat-divider class="mb-2 mt-2"></mat-divider>
            <app-sidenav-menu *ngIf="sidenavMenuItems && sidenavMenuItems.length > 0" [menuItems]="sidenavMenuItems"
                [menuParentId]="0">
            </app-sidenav-menu>
        </mat-sidenav>

        <mat-sidenav-content [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>

<!-- 
<div>
    <mat-sidenav-container>

        <div class="main">
            <router-outlet></router-outlet>
        </div>

    </mat-sidenav-container>

</div> -->